import { render } from "./FormSagepaymentsUpdate.vue?vue&type=template&id=8c85618a&scoped=true"
import script from "./formsagepaymentsupdate.view.js?vue&type=script&lang=js&external"
export * from "./formsagepaymentsupdate.view.js?vue&type=script&lang=js&external"

import "./formsagepaymentsupdate.css?vue&type=style&index=0&id=8c85618a&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c85618a"]])

export default __exports__